/**
 * Datos estructurados (JSON-LD) para fichas, destinos y home.
 */

export function organizationSchema(origin) {
	return {
		"@type": "Organization",
		"@id": `${origin}/#organization`,
		name: "Viajes Molones",
		url: origin,
		logo: `${origin}/logo512.png`,
	};
}

export function websiteSchema(origin) {
	return {
		"@type": "WebSite",
		"@id": `${origin}/#website`,
		name: "Viajes Molones",
		url: origin,
		inLanguage: "es-ES",
		publisher: { "@id": `${origin}/#organization` },
	};
}

export function breadcrumbSchema(origin, crumbs) {
	return {
		"@type": "BreadcrumbList",
		itemListElement: crumbs.map((crumb, index) => ({
			"@type": "ListItem",
			position: index + 1,
			name: crumb.name,
			item: `${origin}${crumb.path}`,
		})),
	};
}

export function destinationsItemList(origin, landings) {
	const list = Object.values(landings);
	return {
		"@type": "ItemList",
		name: "Guías de viaje por destino",
		numberOfItems: list.length,
		itemListElement: list.map((landing, index) => ({
			"@type": "ListItem",
			position: index + 1,
			url: `${origin}/${landing.slug}`,
			name: landing.h1 || `Guía de ${landing.name}`,
		})),
	};
}

export function landingJsonLd(landing, origin) {
	const path = `/${landing.slug}`;
	const url = `${origin}${path}`;
	const graph = [
		organizationSchema(origin),
		websiteSchema(origin),
		{
			"@type": "WebPage",
			"@id": `${url}#webpage`,
			url,
			name: `${landing.seoTitle} · Viajes Molones`,
			description: landing.seoDescription,
			inLanguage: "es-ES",
			isPartOf: { "@id": `${origin}/#website` },
			about: {
				"@type": "City",
				name: landing.name,
			},
		},
		breadcrumbSchema(origin, [
			{ name: "Inicio", path: "/" },
			{ name: "Destinos", path: "/destinos" },
			{ name: landing.name, path },
		]),
	];

	const days = landing.itineraryPreview || [];
	if (days.length) {
		graph.push({
			"@type": "TouristTrip",
			name: landing.h1,
			description: landing.lead,
			touristType: "Viajero independiente",
			itinerary: {
				"@type": "ItemList",
				numberOfItems: days.length,
				itemListElement: days.map((row, index) => ({
					"@type": "ListItem",
					position: index + 1,
					name: `Día ${row.day}: ${row.title}`,
					description: row.note,
				})),
			},
		});
	}

	const facts = landing.cityFacts || [];
	if (facts.length) {
		graph.push({
			"@type": "FAQPage",
			mainEntity: facts.map((fact) => ({
				"@type": "Question",
				name: fact.title,
				acceptedAnswer: {
					"@type": "Answer",
					text: fact.text,
				},
			})),
		});
	}

	return { "@context": "https://schema.org", "@graph": graph };
}

export function destinosJsonLd(origin, landings) {
	return {
		"@context": "https://schema.org",
		"@graph": [
			organizationSchema(origin),
			websiteSchema(origin),
			{
				"@type": "CollectionPage",
				"@id": `${origin}/destinos#webpage`,
				url: `${origin}/destinos`,
				name: "Guías de viaje por destino · Viajes Molones",
				inLanguage: "es-ES",
				isPartOf: { "@id": `${origin}/#website` },
			},
			breadcrumbSchema(origin, [
				{ name: "Inicio", path: "/" },
				{ name: "Destinos", path: "/destinos" },
			]),
			destinationsItemList(origin, landings),
		],
	};
}

export function homeJsonLd(origin, landings) {
	return {
		"@context": "https://schema.org",
		"@graph": [
			organizationSchema(origin),
			websiteSchema(origin),
			{
				"@type": "WebPage",
				"@id": `${origin}/#webpage`,
				url: `${origin}/`,
				name: "Guías de viaje interactivas · Viajes Molones",
				inLanguage: "es-ES",
				isPartOf: { "@id": `${origin}/#website` },
			},
			destinationsItemList(origin, landings),
		],
	};
}

